import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, media } from "@/lib/api";
import { useApp } from "@/lib/store";
import ScientistChat from "./ui/ScientistChat";
import COAPanel from "./ui/COAPanel";
import { FlaskConical, ArrowRight, MessageSquare, ShieldCheck, Sparkles } from "lucide-react";

// WebGL-free commerce-safe experience. Never blocks shopping.
export default function ImmersiveLite({ world, track }) {
  const [catalog, setCatalog] = useState([]);
  const [sci, setSci] = useState(null);
  const [coa, setCoa] = useState(false);
  const navigate = useNavigate();
  const { addToCart } = useApp();

  useEffect(() => { api.get("/vr/catalog").then(({ data }) => setCatalog(data)).catch(() => {}); }, []);

  return (
    <div className="fixed inset-0 z-[60] bg-[#05070a] overflow-y-auto" data-testid="vr-lite">
      <div className="max-w-6xl mx-auto px-5 py-10">
        <div className="flex items-center justify-between">
          <div className="text-cyan-300 font-mono text-xs tracking-widest flex items-center gap-2"><Sparkles size={14} /> CG LABZ IMMERSIVE LITE</div>
          <button onClick={() => navigate("/")} className="text-slate-400 text-sm hover:text-white">Exit</button>
        </div>
        <h1 className="text-4xl sm:text-5xl font-semibold text-white mt-6">The Lab, in Lite mode</h1>
        <p className="text-slate-400 mt-2 max-w-xl">Your device couldn't launch the full 3D laboratory, so here's the fast experience — same products, research, scientists and checkout.</p>
        <div className="flex flex-wrap gap-3 mt-5">
          <button onClick={() => setSci("nova")} className="rounded-xl px-4 py-2.5 border border-violet-400/40 text-violet-200 flex items-center gap-2"><MessageSquare size={15} /> Ask a Scientist</button>
          <button onClick={() => setCoa(true)} className="rounded-xl px-4 py-2.5 border border-emerald-400/40 text-emerald-200 flex items-center gap-2"><ShieldCheck size={15} /> Verify a Batch</button>
          <button onClick={() => navigate("/tools/calculator")} className="rounded-xl px-4 py-2.5 border border-white/15 text-slate-200">Precision Calculator</button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
          {catalog.map((p) => (
            <div key={p.slug} className="rounded-2xl bg-white/[0.03] border border-white/10 overflow-hidden group" data-testid={`lite-product-${p.slug}`}>
              <div className="aspect-square bg-black/40 overflow-hidden">
                {p.image && <img src={media(p.image)} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition" />}
              </div>
              <div className="p-3">
                <div className="text-sm font-semibold text-white line-clamp-1">{p.name}</div>
                <div className="text-xs text-slate-400 font-mono mt-0.5">from ${(p.from_price || 0).toFixed(2)}</div>
                <button onClick={() => navigate(`/shop/${p.slug}`)} className="mt-2 w-full text-xs rounded-lg bg-cyan-400 text-black py-1.5 font-semibold flex items-center justify-center gap-1">View <ArrowRight size={12} /></button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {sci && <ScientistChat world={world} startKey={sci} context={{}} onClose={() => setSci(null)} />}
      {coa && <COAPanel onClose={() => setCoa(false)} track={track} />}
    </div>
  );
}
